import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[slug]/register/driver/page.js");
